import type { CoachingModal as Modal } from '@/core/state/appStore'

export const ACTION_TO_MODAL: Record<string, Modal> = {
  'open-verbis-lebenslauf': 'verbis-lebenslauf',
  'open-kompetenzfeststellung': 'kompetenzfeststellung',
  'open-kompetenzbilanzierung': 'kompetenzbilanzierung',
}

export const ENTRY = { label: 'Teilnehmende anlegen', action: 'open-teilnehmende-anlegen' } as const
